export default __webpack_public_path__ + "imgs/loading.5e14496.jpg";